module.exports = __webpack_public_path__ + "static/media/facebook.a07e508a.svg";